export const Z_INDEX = {
  NONE: 0,
  BASE: 1,
  LOW: 2,
  MID: 3,
  HIGH: 4,
  MAX: 5,
  NAVBAR: 10,
  OFFERS_NAV: 11,
  ORDER_BAR: 99,
  DRAWER: 100,
  MODAL: 101,
  POPUP: 102,
  DIALOG: 103,
  TOAST: 104,
  OVERLAY: 105,
  LOADING: 106,
  CRITICAL: 110,
} as const;
